import React from 'react';
import './status-text.scss';

interface StatusProps {
  text: string;
}

export const StatusText: React.FC<StatusProps> = ({ text }) => {
  return (
    <>
      <div className={`status-text ${text.toLowerCase()}`}>{text}</div>
    </>
  );
};
